import { Field, Float, InputType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import type { InventoryTypeEnum } from '../../inventory/InventoryTypeEnum'

@InputType()
export class InventoryItemWithSerialNumbers {
  @Field(() => String)
  productId: string

  @Field(() => Float)
  quantity: number

  @Field(() => [SerialNumberInput], { nullable: true })
  inventoryBySerialNumbers?: SerialNumberInput[]

  @Field(() => String, { nullable: true })
  remarks?: string
}

@InputType()
export class SerialNumberInput {
  @Field(() => String)
  code: string
}

@InputType()
export class UpdateProductInventoryWithSerialNumbersArgs extends ActionArgs {
  @Field(() => [InventoryItemWithSerialNumbers])
  items: InventoryItemWithSerialNumbers[]

  @Field(() => String)
  transactionRef: string

  @Field(() => String)
  transactionType: InventoryTypeEnum

  @Field(() => String)
  batchCode: string

  @Field(() => String)
  defaultRemarks: string
}

export interface IUpdateProductInventoryWithSerialNumbers
  extends IAction<void, UpdateProductInventoryWithSerialNumbersArgs> {}
